import { getNavigationType } from '../../utils/get-navigation-type.js';
export const buildViewFrontpageEvent = (inputProperties) => ({
    ...inputProperties,
    object: Promise.resolve(inputProperties.object).then((objectProperties) => {
        return {
            ...objectProperties,
            navigationType: getNavigationType(),
            type: 'Frontpage',
            url: window.location.href,
        };
    }),
});
//# sourceMappingURL=event-builder.js.map